import { Button, Grid, TextField, Tooltip } from '@mui/material';
import CustomAccordion from '../CustomAccordion/CustomAccordion';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import { resetCompanyNamePICInput, setCompanyNamePICInputExpand, setSelectedCompanyNamePICId, setTriggerFocusCompanyNameInput, setCompanyNamePICInput, setContactDetails, setCompanyName, setPIC, setEmailTo, setEmailCc } from './reducers/CompanyNamePICInputReducer';
import BaseResponse from '../../app/BaseResponse';
import Utility from '../../app/utility';
import { showLoading } from '../LoadingView/reducers/LoadingViewReducer';
import { CompanyNamePICInputSelector } from './reducers/CompanyNamePICInputReducer';
import CompanyNamePICApi from './api/CompanyNamePICApi';
import CompanyNamePICModel from './models/CompanyNamePICModel';
import { contactInputSelector } from '../Contact/reducers/ContactInputReducer';
import CompanyNamePICSelector from '../CompanyNamePICSelector/CompanyNamePICSelector';

const CompanyNamePICInput: React.FunctionComponent = () => {
    const dispatch = useDispatch();
    const companyNamePICInputViewData = useSelector(CompanyNamePICInputSelector);
    const contactInputViewData = useSelector(contactInputSelector);

    useEffect(() => {
        if (companyNamePICInputViewData.triggerSave > 0) {
            save();
        }
    }, [companyNamePICInputViewData.triggerSave]);

    useEffect(() => {
        if (companyNamePICInputViewData.triggerRefreshInput > 0) {
            refreshInput();
        }
    }, [companyNamePICInputViewData.triggerRefreshInput]);

    const refreshInput = () => {
        dispatch(resetCompanyNamePICInput());
        dispatch(setSelectedCompanyNamePICId(""));
        dispatch(setTriggerFocusCompanyNameInput((new Date()).getTime()));
    }

    useEffect(() => {
        if (companyNamePICInputViewData.selectedCompanyNamePICId.length > 0) {
            selectCompanyNamePICById(companyNamePICInputViewData.selectedCompanyNamePICId);
        }
    }, [companyNamePICInputViewData.selectedCompanyNamePICId])

    const selectCompanyNamePICById = (id: string) => {
        dispatch(showLoading(true));
        CompanyNamePICApi.GetById({
            id: id
        }).then((response: BaseResponse<CompanyNamePICModel>) => {
            if (response.success) {
                dispatch(setCompanyNamePICInput(response.data));

                dispatch(showLoading(false));

            } else {
                Utility.Alert.Error(response.message);
                dispatch(showLoading(false));
            }
        }).catch((error) => {
            Utility.Alert.Error(error);
            dispatch(showLoading(false));
        })
    };

    const save = () => {
        try {
            validate();

            CompanyNamePICApi.Save(companyNamePICInputViewData.companyNamePICInput)
                .then((response: BaseResponse<CompanyNamePICModel>) => {
                    if (response.success) {
                        if (companyNamePICInputViewData.companyNamePICInput.id.length === 0) {
                            Utility.Alert.Success("CompanyNamePIC added successful");
                        } else {
                            Utility.Alert.Success("CompanyNamePIC updated successful");
                        }

                        refreshInput();
                    } else {
                        Utility.Alert.Error(response.message);
                    }
                })
                .catch((error) => {
                    Utility.Alert.Error(error);
                });
        } catch (error) {
            Utility.Alert.Error(error);
        }
    }

    const validate = () => {
        if (companyNamePICInputViewData.companyNamePICInput.companyName.length === 0) {
            throw "Company name is required";
        }

        if (companyNamePICInputViewData.companyNamePICInput.pic.length === 0) {
            throw "PIC is required";
        }

        if (companyNamePICInputViewData.companyNamePICInput.emailTo.length === 0) {
            throw "EmailTo is required";
        }
    }

    return (
        <>
            {
                <CustomAccordion
                    title="Input"
                    defaultOpen={true}
                    className="top-quick-input"
                    open={companyNamePICInputViewData.companyNamePICInputExpand}
                    onOpenChange={(isOpen: boolean) => {
                        dispatch(setCompanyNamePICInputExpand(isOpen));
                    }}
            >
                    <Grid container>
                        <Grid item lg={3} xs={12}>
                            <Grid container className='cargo-input-component'>
                                <Grid xs={10} lg={9}>
                                    <TextField
                                        label="Company Name"
                                        className="cargo-input-component"
                                        fullWidth
                                        value={companyNamePICInputViewData.companyNamePICInput.companyName}
                                        onChange={(event) => {
                                            dispatch(setCompanyName(event.target.value ? event.target.value : ""));
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={2} lg={3}>
                                    <Tooltip title="Reset (Alt + R)">
                                        <Button
                                            className="clear-input-button"
                                            tabIndex={-1}
                                            color="success"
                                            variant="contained"
                                            onClick={() => {
                                                refreshInput();
                                            }}
                                        >
                                            <i className="fa fa-refresh" aria-hidden="true"></i>
                                        </Button>
                                    </Tooltip>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item lg={2} xs={12}>
                            <TextField
                                label="PIC Name"
                                className="cargo-input-component"
                                fullWidth
                                value={companyNamePICInputViewData.companyNamePICInput.pic}
                                onChange={(event) => {
                                    dispatch(setPIC(event.target.value ? event.target.value : ""));
                                }}
                            />
                        </Grid>
                        <Grid item lg={2} xs={12}>
                            <TextField
                                label="Emails To"
                                className="cargo-input-component tonnage-input-full-tc"
                                multiline
                                rows={3}
                                fullWidth
                                value={companyNamePICInputViewData.companyNamePICInput.emailTo}
                                onChange={(event) => {
                                    dispatch(setEmailTo(event.target.value ? event.target.value : ""));
                                }}
                            />
                        </Grid>
                        <Grid item lg={2} xs={12}>
                            <TextField
                                label="Emails Cc"
                                className="cargo-input-component tonnage-input-full-tc"
                                multiline
                                rows={3}
                                fullWidth
                                value={companyNamePICInputViewData.companyNamePICInput.emailCc}
                                onChange={(event) => {
                                    dispatch(setEmailCc(event.target.value ? event.target.value : ""));
                                }}
                            />
                        </Grid>
                        <Grid item lg={2} xs={12}>
                            <TextField
                                label="Contact Details"
                                multiline
                                fullWidth
                                rows={3}
                                value={companyNamePICInputViewData.companyNamePICInput.contactDetails}
                                onChange={(event) => {
                                    dispatch(setContactDetails(event.target.value ? event.target.value : ""));
                                }}
                                className='cargo-input-component tonnage-input-full-tc'
                            />
                        </Grid>
                        <Grid item lg={1} xs={12}>
                            <Tooltip title="Alt + S">
                                <Button
                                    onClick={save}
                                    variant="outlined"
                                >
                                    Save (s)
                                </Button>
                            </Tooltip>
                        </Grid>
                    </Grid>
                </CustomAccordion>
            }
        </>
    )
};

export default CompanyNamePICInput;